import { useSubfolderLanguageAndLocale } from '@coursera-web/internationalization-lib';

import * as user from 'js/lib/user';

const useEnableSubfolderLinksForXDP = () => {
  const isOnSubfolderRoute = !!useSubfolderLanguageAndLocale();
  return !user.isAuthenticatedUser() && isOnSubfolderRoute;
};

export default useEnableSubfolderLinksForXDP;
